export function departments(api: ReturnType<typeof useAxios>) {
  const getAllDepartments = async (data: any) =>
    await api.$get(
      `/departments?limit=${data.limit}&page=${data.page}&sort=${data.sort}&dir=${data.dir}&search=${encodeURIComponent(data.search)}&status=${data.status}`,
    );
  const createDepartment = async (data: any) => await api.$post(`/departments`, data);
  const deleteDepartment = async (id: any) => await api.$delete(`/departments/${id}`);
  const getDepartment = async (id: any) => await api.$get(`/departments/${id}`);
  const updateDepartment = async (id: any, data: any) => await api.$put(`/departments/${id}`, data);
  const departmentList = async () => await api.$get(`/departments/list`);
  const updateDepartmentStatus = async (id: string, data: any) => await api.$put(`/departments/status/${id}`, data);

  return {
    getAllDepartments,
    createDepartment,
    deleteDepartment,
    getDepartment,
    updateDepartment,
    departmentList,
    updateDepartmentStatus,
  };
}
